import React from 'react'

const CAMPOS = [
  { key: 'movilidad', label: 'Movilidad' },
  { key: 'haber_minimo', label: 'Haber minimo' },
  { key: 'base_imponible_minima', label: 'Base imponible minima' },
  { key: 'pbu_vigente', label: 'PBU vigente' },
]

function formatValor(key, value) {
  const n = Number(value || 0)
  if (key === 'movilidad') return `${(n * 100).toFixed(2)}%`
  return `$ ${n.toLocaleString('es-AR')}`
}

function calcularVariacion(prev, next) {
  const a = Number(prev || 0)
  const b = Number(next || 0)
  if (a === 0) return null
  return ((b / a) - 1) * 100
}

export default function NormativeDiff({ anterior = {}, nuevo = {} }) {
  const camposConCambio = CAMPOS.filter(({ key }) => {
    const prev = Number(anterior[key] || 0)
    const next = Number(nuevo[key] || 0)
    return prev !== next
  })

  return (
    <div className="rounded-xl border border-slate-700 bg-slate-950 p-4 shadow-sm">
      <h4 className="mb-3 text-sm font-semibold text-cyan-100">Comparativa de valores</h4>
      {camposConCambio.length === 0 && (
        <p className="mb-3 rounded-md border border-slate-700 bg-slate-900 px-3 py-2 text-xs text-slate-300">
          Valores economicos sin variaciones en este hito.
        </p>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="border-b border-slate-700 text-left text-xs uppercase tracking-wide text-slate-400">
              <th className="py-2 pr-3">Parametro</th>
              <th className="py-2 pr-3">Anterior</th>
              <th className="py-2 pr-3">Nuevo</th>
              <th className="py-2">Variacion</th>
            </tr>
          </thead>
          <tbody>
            {camposConCambio.map(({ key, label }) => {
              const variacion = calcularVariacion(anterior[key], nuevo[key])
              const up = typeof variacion === 'number' && variacion > 0
              const down = typeof variacion === 'number' && variacion < 0
              return (
                <tr key={key} className="border-b border-slate-800">
                  <td className="py-2 pr-3 font-medium text-slate-200">{label}</td>
                  <td className="py-2 pr-3 text-rose-700">{formatValor(key, anterior[key])}</td>
                  <td className="py-2 pr-3 text-emerald-700">{formatValor(key, nuevo[key])}</td>
                  <td className={`py-2 font-semibold ${up ? 'text-emerald-700' : down ? 'text-rose-700' : 'text-slate-500'}`}>
                    {typeof variacion === 'number' ? `${up ? '▲' : down ? '▼' : '•'} ${Math.abs(variacion).toFixed(2)}%` : 'N/A'}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
